import { jsx as ___EmotionJSX } from "@emotion/core";
import * as React from "react";
import Box from "./Box";
import Form from "./Form";
import { css } from "./Theme";
import Property from "./EditorProperty";

const Editor = props => {
  const styles = css({
    bg: "background.primary",
    minWidth: "320px",
    height: "100%",
    py: 3,
    overflow: "scroll",
    borderLeft: "1px solid",
    borderColor: "background.tertiary",
    zIndex: 1
  });
  return ___EmotionJSX(Box, {
    css: styles
  }, ___EmotionJSX(Form, null, props.children));
};

export default Editor;
export { Property };